import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visible: false,
  type: 'INFO',
  payload: null
};

const sessionModalSlice = createSlice({
  name: 'sessionModal',
  initialState,
  reducers: {
    openSessionModal: (state, action) => {
      state.visible = true;
      state.type = action.payload?.type ?? 'INFO';
      state.payload = action.payload ?? null;
    },
    closeSessionModal: (state) => {
      state.visible = false;
      state.type = 'INFO';
      state.payload = null;
    },
    updateSessionModal: (state, action) => {
      state.payload = { ...(state.payload || {}), ...(action.payload || {}) };
    }
  }
});

export const { openSessionModal, closeSessionModal, updateSessionModal } =
  sessionModalSlice.actions;

export default sessionModalSlice.reducer;
